import React, { FC, RefObject, useMemo, useRef } from 'react';
import { IMappedField } from '../../../slice/types';
import { mapColors } from '../../../slice/map-constants';
import { Polygon } from 'react-leaflet';
import { PathOptions, Polygon as PolygonType } from 'leaflet';

interface IProps {
  mappedField: IMappedField;
}

const DisabledField: FC<IProps> = ({ mappedField }) => {
  const polygonRef: RefObject<PolygonType<any>> | null = useRef(null);

  const polygonPathOptions = useMemo((): PathOptions => {
    return {
      color: mapColors.colors.DEFAULT,
      fillColor: '#fff',
      fillOpacity: 0.6,
      opacity: 1,
      dashArray: '5, 10',
      lineCap: 'round',
    };
  }, []);

  return (
    <>
      <Polygon
        pmIgnore={true}
        pathOptions={polygonPathOptions}
        positions={mappedField.coordinates}
        ref={polygonRef}
      />
    </>
  );
};
export default DisabledField;
